if (!customElements.get('flagship-store')) {
  class FlagshipStore extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector('[data-map-button]');
      this.media = this.querySelector('.flagship-store__media') || this.querySelector('.flagship-store-card__media');
      this.map = this.querySelector('.flagship-store__map') || this.querySelector('.flagship-store-card__map');
      this.isVisible = false;

      this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.initialButtonText = this.toggleBtn.textContent.trim();
      this.activeStateButtonText = this.toggleBtn.dataset.activeText ?? window.accessibilityStrings.images;

      this.toggleBtn.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.hide();
      this.toggleBtn.removeEventListener('click', this.handleClick);
    }

    onClick() {
      this.isVisible ? this.hide() : this.show();
    }

    show() {
      this.isVisible = true;
      this.media.classList.add('active');
      this.toggleBtn.innerText = this.activeStateButtonText;
    }

    hide() {
      this.isVisible = false;
      this.media.classList.remove('active');
      this.toggleBtn.innerText = this.initialButtonText;
    }
  }

  customElements.define('flagship-store', FlagshipStore);
}